import { KeyValueModel } from "model";
import { EnumTpEvento } from "model/enums/enum-tp-evento";

export const TpEventoMock: KeyValueModel[] = [
    new KeyValueModel(EnumTpEvento.Emissao, "Emissão"),
    new KeyValueModel(EnumTpEvento.Cancelamento, "Cancelamento"),
    new KeyValueModel(EnumTpEvento.Inutilizacao, "Inutilização"),
    new KeyValueModel(EnumTpEvento.Denegado, "Denegado"),
    new KeyValueModel(EnumTpEvento.Entrada, "Entrada"),
    new KeyValueModel(EnumTpEvento.ResumoNFe, "Resumo da NF-e"),
    new KeyValueModel(EnumTpEvento.ResumoEvento, "Resumo de Evento"),
    new KeyValueModel(EnumTpEvento.EventosDeAverbacao, "Averbação"),
    new KeyValueModel(EnumTpEvento.EPEC, "EPEC"),
    new KeyValueModel(EnumTpEvento.EventoDeCartaDeCorrecao, "Carta de Correção"),
    new KeyValueModel(EnumTpEvento.EventosDeConfirmacaoDeOperacao, "Confirmação da Operação"),
    new KeyValueModel(EnumTpEvento.EventosDeCienciaDaOperacao, "Ciência da Operação"),
    new KeyValueModel(EnumTpEvento.EventosDeDesconhecimentoDaOperacao, "Desconhecimento da Operação"),
    new KeyValueModel(EnumTpEvento.EventosDeOperacaoNaoRealizada, "Operação Não Realizada"),
    new KeyValueModel(EnumTpEvento.EventosDeInternalizacaoSUFRAMA, "Internalização SUFRAMA"),
    new KeyValueModel(EnumTpEvento.EventosDeVistoriaSUFRAMA, "Vistoria SUFRAMA"),
    new KeyValueModel(EnumTpEvento.EventosDeVistoriaSUFRAMASEFAZ, "Vistoria SUFRAMA / SEFAZ"),
    new KeyValueModel(EnumTpEvento.EventosDePedidoDeProrrogacaoDePrazo1, "Pedido de Prorrogação de Prazo (1)"),
    new KeyValueModel(EnumTpEvento.EventosDePedidoDeProrrogacaoDePrazo2, "Pedido de Prorrogação de Prazo (2)"),
    new KeyValueModel(EnumTpEvento.EventosDeCancelamentoDePedidoDeProrrogacaoDePrazo1, "Cancelamento do Pedido de Prorrogação (1)"),
    new KeyValueModel(EnumTpEvento.EventosDeCancelamentoDePedidoDeProrrogacaoDePrazo2, "Cancelamento do Pedido de Prorrogação (2)"),
    new KeyValueModel(EnumTpEvento.EventosDoFiscoEmRespostaAoPedidoDeProrrogacao1, "Resposta do Fisco ao Pedido de Prorrogação (1)"),
    new KeyValueModel(EnumTpEvento.EventosDoFiscoEmRespostaAoPedidoDeProrrogacao2, "Resposta do Fisco ao Pedido de Prorrogação (2)"),
    new KeyValueModel(EnumTpEvento.EventosDoFiscoEmRespostaDeCancelamentoAoPedidoDeProrrogacao1, "Resposta do Fisco ao Cancelamento (1)"),
    new KeyValueModel(EnumTpEvento.EventosDoFiscoEmRespostaDeCancelamentoAoPedidoDeProrrogacao2, "Resposta do Fisco ao Cancelamento (2)"),
];
